import {useMemo} from 'react';
import ReportsNOFilter from '../../../components/no-filters/reports-geography-filter';
import RosterTabContent from './RosterTabContent';
import {ReportsPageTab, type ViewType} from '../useReportsPageController';
import NetworkAdequacyTabContent from './NetworkAdequacyTabContent';
import Button from '../../../../../components/button';
import './ReportsPageTabView.scss';

interface IReportsPageTabViewProps {
    selectedViewType: ViewType;
    onSelectedViewTypeChange: (viewType: ViewType) => void;
    activeTab: ReportsPageTab,
    currentViewTypes: ViewType[];
    generateReportPath: string;
}

const ReportsPageTabView = (props: IReportsPageTabViewProps) => {
    const {
        selectedViewType, 
        onSelectedViewTypeChange, 
        activeTab, 
        currentViewTypes, 
        generateReportPath
    } = props;

    const generateReportButton: React.ReactNode = useMemo(() => {
        return (
            <Button
                color='milliman-blue'
                className='generate-report-btn'
                onClick={() => window.open(generateReportPath, '_blank')}
            >
                Generate Report
            </Button>
        );
    }, [generateReportPath]);

    return (
        <div className="bg-background-gray-100 relative text-lg">
            <div className="p-4 px-12">
                <div className="p-4 bg-white reports-page">
                    <div className="network-analysis-page flex justify-between items-center">
                        <ReportsNOFilter
                            selectedViewType={selectedViewType}
                            activeTab={activeTab}
                        />
                    </div>
                    {activeTab === ReportsPageTab.Roster && <RosterTabContent
                        selectedViewType={selectedViewType}
                        onSelectedViewTypeChange={onSelectedViewTypeChange}
                        currentViewTypes={currentViewTypes}
                        generateReportButton={generateReportButton}
                    />}
                    {activeTab === ReportsPageTab.NetworkAdequacy && <NetworkAdequacyTabContent 
                        selectedViewType={selectedViewType} 
                        onSelectedViewTypeChange={onSelectedViewTypeChange}
                        currentViewTypes={currentViewTypes}
                        generateReportButton={generateReportButton}
                    />}
                </div>
            </div>
        </div>
    );
};

export default ReportsPageTabView;